import { Heading, Paragraph } from '@digdir/designsystemet-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageWrapper } from '../solceller';

import { ValgfriDetaljeringForm } from './form';

export const ValgfriDetaljering = () => {
  const { t } = useTranslation('', { keyPrefix: 'form.valgfriDetaljering' });

  return (
    <PageWrapper>
      <Heading level={2} data-size="lg">
        {t('pageTitle')}
      </Heading>
      <Paragraph className="text-preline">{t('info')}</Paragraph>
      <ValgfriDetaljeringForm />
    </PageWrapper>
  );
};
